import { render, staticRenderFns } from "./PopModal.vue?vue&type=template&id=2aedfb9e"
import script from "./PopModal.vue?vue&type=script&lang=js"
export * from "./PopModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports